/* eslint-disable no-restricted-syntax */
import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { IState } from 'store';

import api from 'services/api';
import { IDentalDuplicateState, IDentalDuplicateTypes } from './types';

import {
  dentalDuplicateRequest,
  dentalDuplicateSuccess,
  dentalDuplicateFailure,
} from './actions';

type IDentalDuplicateType = ReturnType<typeof dentalDuplicateRequest>;

export function* dentalDuplicate({ payload }: IDentalDuplicateType) {
  try {
    const { type, attachment } = payload;

    const getCpf = (state: IState) => state.auth.cpf;
    const cpf: string = yield select(getCpf);

    const getMatricula = (state: IState) => state.user.current?.cdMatricula;
    const matricula: string = yield select(getMatricula);

    const getDental = (state: IState) => state.dentalDuplicate;
    const { data }: IDentalDuplicateState = yield select(getDental);

    const defineOtherReason = () => {
      switch (data?.optionId) {
        case '1':
          return '30 dias de plano, mas não recebeu a carteirinha';
        case '2':
          return 'Carteirinha com nome incorreto';
        case '3':
          return 'Alterar nome';
        default:
          return '';
      }
    };

    const defineDescricaoMotivo = () => {
      switch (type) {
        case 'Perda':
          return 'Perda do Cartão';
        case 'Avaria':
          return 'Quebra ou Avaria';
        case 'Roubo':
          return 'Roubo ou Furto';
        case 'Outros':
          return defineOtherReason();
        default:
          return '';
      }
    };

    for (const dependent of data?.dependents || []) {
      const formData = new FormData();

      formData.append('cpf', cpf);
      formData.append('matricula', matricula);
      formData.append('tipoMotivo', type);
      formData.append('tipoPlano', 'PO');
      formData.append('nomeSolicitanteCarteirinha', dependent.name);
      formData.append(
        'descricaoMotivo',
        defineDescricaoMotivo().charAt(0).toUpperCase() +
          defineDescricaoMotivo().slice(1).toLowerCase(),
      );

      if (attachment) {
        formData.append('anexo', attachment);
      }

      yield call(api.post, '/portal-conecta/segunda-via-carteirinha', formData);
    }

    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'solicitationFormSubmitted',
      formName: `Dental - Segunda Via - ${
        type !== 'Outros'
          ? defineDescricaoMotivo()
          : `Outros - ${defineOtherReason()}`
      }`,
    });

    yield put(dentalDuplicateSuccess());
  } catch (err) {
    if (err && err?.response) {
      const response = {
        status: err.response?.status,
        message: err.response?.data.message,
      };

      yield put(dentalDuplicateFailure(response));
      return;
    }

    yield put(
      dentalDuplicateFailure({
        status: 500,
        message: 'Erro interno de servidor',
      }),
    );
  } finally {
    const { handleClickNextStep } = payload;

    handleClickNextStep();
  }
}

export default all([
  takeLatest(IDentalDuplicateTypes.DENTAL_DUPLICATE_REQUEST, dentalDuplicate),
]);
